import React, { useCallback, useEffect, useState } from 'react';
import { useAbility } from '@casl/react';
import { MenuItem, SubMenu } from 'react-contextmenu';
import { Card, Col, Row } from 'react-bootstrap';
import { AbilityContext } from '../../config/abilityContext';
import './style.scss';
import IterateArray from './FolderAndDocuments';
import DocumentsTable from './DocumentsTable';
import Icon from '../Icons';
import findNodeRecursive from '../../screens/Shared/DirectoryNode/helpers';
import FolderActionButtons from './FolderActionButtons';
import { useDirectoryNodes } from './DirectoryNodesContext';

const DocumentsTabContainer = ({
  handleOpenCenterModal,
  handleButtonClick,
  permitedActions,
  permitedCreations,
  fetchRequestWithId,
  handleMoveDocument,
  handleMoveFolder,
  maxDepth,
  handleFirstNodeRequest,
  handleLoadMoreDocuments
}) => {
  const ability = useAbility(AbilityContext);
  const canMoveFile = ability.can('update_location', 'Document');
  const [currentFolder, setCurrentFolder] = useState(null);
  const [parentId, setParentId] = useState(null);

  const { directoryNodes, selectedFolder } = useDirectoryNodes();

  const getCurrentFolder = useCallback(() => {
    const folder = findNodeRecursive(directoryNodes, selectedFolder);
    setCurrentFolder(folder);
  }, [directoryNodes, selectedFolder]);

  useEffect(() => {
    getCurrentFolder();
  }, [getCurrentFolder]);

  const createSubMenus = (directoryNode, documentId) => {
    const { id: directoryNodeId } = directoryNode;

    return (
      <div key={`directory-${directoryNode.id}-document-${documentId}`}>
        {directoryNode.hasChildren && directoryNode.children ? (
          <SubMenu
            title={
              <>
                <span>{directoryNode.name}</span>
                <Icon className="float-right mt-1" height={15} icon="chevron-forward" />
              </>
            }
            onClick={() => handleMoveDocument(directoryNodeId, documentId)}
          >
            {directoryNode.children?.map(children => createSubMenus(children, documentId))}
          </SubMenu>
        ) : (
          <MenuItem onClick={() => handleMoveDocument(directoryNodeId, documentId)}>{directoryNode.name}</MenuItem>
        )}
      </div>
    );
  };

  return (
    <>
      <Row>
        <Col xs={12} md={3} lg={3}>
          <Card>
            <Card.Title className="mb-1">
              <h4 className="mb-0 text-center pt-2 mt-0">Directorio</h4>
              <hr className="my-1" />
            </Card.Title>
            <Card.Body className="p-0">
              <IterateArray
                setParentId={setParentId}
                childrenArray={directoryNodes}
                handleOpenCenterModal={handleOpenCenterModal}
                handleButtonClick={handleButtonClick}
                permitedActions={permitedActions}
                permitedCreations={permitedCreations}
                fetchRequestWithId={fetchRequestWithId}
                maxDepth={maxDepth}
                directoryNodes={directoryNodes}
                root
                canMoveFile={canMoveFile}
                ability={ability}
                handleFirstNodeRequest={handleFirstNodeRequest}
                handleLoadMoreDocuments={handleLoadMoreDocuments}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={9} lg={9}>
          <Card>
            <Card.Title className="mb-1">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-start">
                  <Icon icon="menu" className="ml-2 pt-2" width="30px" height="30px" />
                  <h4 className="mb-0 text-start pt-1 px-2 mt-1">
                    {currentFolder?.name || 'Selecciona un directorio'}
                  </h4>
                </div>
                <div className="d-flex justify-content-end">
                  <FolderActionButtons
                    handleButtonClick={handleButtonClick}
                    parentId={parentId}
                    folder={currentFolder}
                    ability={ability}
                    handleMoveFolder={handleMoveFolder}
                    directoryNodes={directoryNodes}
                    hasPermissionsToAddFiles={permitedCreations.find(e => e === 'node' || e === 'file')}
                    handleOpenCenterModal={handleOpenCenterModal}
                    handleFirstNodeRequest={handleFirstNodeRequest}
                  />
                </div>
              </div>
              <hr className="my-1" />
            </Card.Title>
            <Card.Body>
              <DocumentsTable
                documents={currentFolder?.documents || []}
                handleButtonClick={handleButtonClick}
                parentId={parentId}
                permitedActions={permitedActions}
                handleLoadMoreDocuments={handleLoadMoreDocuments}
                handleMoveDocument={handleMoveDocument}
                nextPage={currentFolder?.nextPage}
                isLoading={currentFolder?.isLoading}
                canMoveFile={canMoveFile}
                directoryNodes={directoryNodes}
                createSubMenus={createSubMenus}
                folderId={currentFolder?.id}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DocumentsTabContainer;
